export const kycMethodsList = ['System KYC', 'Sumsub']
